// @flow
import { connect } from 'react-redux'
import Segmentation from './Segmentation'
import type { Store } from '../../redux/ducks'
import * as segmentationReducer from '../../redux/ducks/segmentation/reducers'
import { patch } from '../AudienceEditContainer'
import _ from 'lodash'
import { Audience } from '../constants'
import store from '../../redux/store'

function mapStateToProps(state: Store) {
  const segmentation = state.segmentation

  return {
    value: [
      ...(segmentation.segmentByLocations ? ['locations'] : []),
      ...(segmentation.segmentByGender ? ['gender'] : []),
      ...(segmentation.segmentByAge ? ['age'] : []),
      ...(segmentation.segmentByProviders ? ['providers'] : []),
      ...(segmentation.segmentByFbPlacements ? ['fb_placements'] : []),
      ...(segmentation.segmentByImportantParams ? ['important_params'] : []),
      ...(segmentation.segmentByTargetingSources ? ['targeting_sources'] : []),
      ...(segmentation.segmentByVkApps ? ['vk_apps'] : []),
      ...(segmentation.segmentByVkGroups ? ['vk_groups'] : []),
      ...(segmentation.segmentByKeywords ? ['keywords'] : []),
      ...(segmentation.segmentByVkActivity ? ['vk_activity'] : []),
      ...(segmentation.segmentByInterests ? ['interests'] : []),
      ...(segmentation.segmentByPlatform ? ['platform'] : []),
      ...(segmentation.segmentByPlacementType ? ['placement_type'] : [])
    ]
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (value: Array<string>) => {
      dispatch(
        segmentationReducer.patch({
          segmentByLocations: _.includes(value, 'locations'),
          segmentByGender: _.includes(value, 'gender'),
          segmentByAge: _.includes(value, 'age'),
          segmentByProviders: _.includes(value, 'providers'),
          segmentByFbPlacements: _.includes(value, 'fb_placements'),
          segmentByImportantParams: _.includes(value, 'important_params'),
          segmentByTargetingSources: _.includes(value, 'targeting_sources'),
          segmentByVkApps: _.includes(value, 'vk_apps'),
          segmentByVkGroups: _.includes(value, 'vk_groups'),
          segmentByKeywords: _.includes(value, 'keywords'),
          segmentByVkActivity: _.includes(value, 'vk_activity'),
          segmentByInterests: _.includes(value, 'interests'),
          segmentByPlatform: _.includes(value, 'platform'),
          segmentByPlacementType: _.includes(value, 'placement_type')
        })
      )
      if (!_.includes(value, 'providers')) {
        const state = store.getState()
        const { vkPlacement } = state.audienceEdit
        if (vkPlacement === Audience.vk_placements.promopost_with_big_image)
          patch(dispatch, { vkPlacement: Audience.vk_placements.default_vk_placement })
      }
    }
  }
}

const SegmentationContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(Segmentation)

export default SegmentationContainer
